export const siteContent = {
  projectName: "Senderos de Rumencó",
  projectTagline: "Barrio privado premium",
  developer: "H Ledesma Desarrollos Inmobiliarios",
  finalUrl: "https://inversiones.hledesma.com/senderosderumenco",

  header: {
    title: "Senderos de Rumencó",
    subtitle: "Barrio privado premium en la zona sur de Mar del Plata.",
  },

  hero: {
    eyebrow: "Anticipo y 24 Cuotas",
    title: "Tu lote en un barrio privado con todo. Ubicación privilegiada, amenities e infraestructura",
    description:
      "Conocé Senderos de Rumencó, una propuesta pensada para quienes buscan lotes con ubicación privilegiada, amenities e infraestructura dentro de un entorno exclusivo.",
    cta: "Solicitá información",
    highlights: [
      { value: "255", label: "parcelas residenciales" },
      { value: "+700 m²", label: "superficie por lote" },
      { value: "+8", label: "amenities" },
      { value: "<20 min", label: "de puntos de la ciudad" },
    ],
  },

  benefits: {
    eyebrow: "Barrio privado premium",
    title: "Calidad residencial, infraestructura y entorno natural",
    description:
      "Un desarrollo residencial de alta calidad, pensado para quienes buscan un entorno seguro, ordenado y con servicios orientados al bienestar y la vida familiar.",
    items: [
      "Desarrollo residencial de alta calidad",
      "Entorno seguro y ordenado",
      "Infraestructura de primer nivel",
      "Diseño urbano cuidado",
      "Integración con el entorno natural",
    ],
    cta: "Solicitar información",
  },

  gallery: {
    eyebrow: "Imágenes del proyecto",
    title: "Senderos de Rumencó",
    images: [
      { src: "images/01.webp" },
      { src: "images/02.webp" },
      { src: "images/03.webp" },
      { src: "images/04.webp" },
      { src: "images/05.webp" },
      { src: "images/06.webp" },
    ],
  },

  amenitiesInfra: {
    eyebrow: "Amenities e infraestructura",
    title: "Servicios pensados para la vida diaria",
    description:
      "El proyecto prioriza la calidad de vida y el contacto con la naturaleza, integrando amplias áreas verdes y arboledas preservadas, además de un sector deportivo y un Club House de uso exclusivo.",
    amenities: [
      "Cancha de fútbol 11",
      "Gimnasio cubierto totalmente equipado",
      "Canchas de tenis",
      "Canchas de pádel cubiertas",
      "Club House",
      "Piscina de uso exclusivo",
      "SUM (Salón de Usos Múltiples) con capacidad para 60 personas",
      "Vestuarios y estacionamiento",
    ],
    infrastructure: [
      "Agua potable",
      "Electricidad",
      "Red cloacal directa de OSSE",
      "Desagüe pluvial",
      "Calles asfaltadas",
      "Recolección de residuos",
    ],
    image: "images/07.webp",
  },

  details: {
    eyebrow: "Detalles del barrio",
    title: "Ubicación, parcelas y planificación",
    description:
      "Un trazado urbano integrado al entorno natural, con conectividad a la ciudad y servicios para una vida familiar cómoda.",
    items: [
      {
        id: 1,
        title: "Ubicación (zona sur de Mar del Plata)",
        content:
          "Se emplaza en la zona sur, con acceso directo desde Av. Jorge Newbery (ensanchada recientemente). Conecta con el centro, las rutas provinciales a través de la circunvalación y con las playas más exclusivas (desde la Reserva del Faro hasta Chapadmalal). En el entorno inmediato se desarrollará el Distrito Comercial Senderos, con servicios deportivos, de salud, comerciales y gastronómicos.",
        image: "images/04.webp",
      },
      {
        id: 2,
        title: "255 parcelas residenciales",
        content:
          "Contempla un total de 255 parcelas residenciales destinadas exclusivamente a viviendas unifamiliares, con superficies entre 700 m² y 900 m².",
        image: "images/02.webp",
      },
      {
        id: 3,
        title: "Masterplan y entorno natural",
        content:
          "Diseñado respetando el relieve natural y la vegetación existente, integrando áreas boscosas vinculadas al Bosque Peralta Ramos. Dos boulevards principales (Norte y Sur) estructuran el barrio, conectando siete loteos internos. En el cruce se genera una plazoleta con juegos infantiles.",
        image: "images/01.webp",
      },
      {
        id: 4,
        title: "Sector deportivo y Club House",
        content:
          "Incluye circulaciones peatonales, áreas de descanso, vestuarios y estacionamiento. El Club House contará con piscina de uso exclusivo y SUM para 60 personas.",
        image: "images/06.webp",
      },
      {
        id: 5,
        title: "Infraestructura",
        content:
          "Infraestructura con agua potable, electricidad, red cloacal directa de OSSE, desagüe pluvial, calles asfaltadas y recolección de residuos.",
        image: "images/infra.webp",
      },
    ],
  },

  form: {
    title: "Solicitá más información",
    subtitle: "Dejanos tus datos y te contactamos.",
    submit: "Recibir información",
    loading: "Enviando...",
    success: "Datos enviados",
    consent: "Acepto recibir información por email",
  },

  promo: {
    eyebrow: "Contacto comercial",
    title: "Recibí la información del proyecto",
    description:
      "Completá el formulario para conocer características, disponibilidad y próximos pasos.",
  },

  location: {
    eyebrow: "Ubicación",
    title: "Un espacio reservado, cerca de todo",
    description:
      "Sobre Av. Jorge Newbery. Distancias aproximadas: 10 min de Multiespacio BENDU, 20 min al centro, 15 min de Güemes, 15 min de Chapadmalal, 10 min de las playas del sur, 12 min del puerto y 3 min de supermercados COTO.",
  },

  subfooter: {
    title: "Senderos de Rumencó",
    subtitle: "Barrio privado premium",
    cta: "Solicitar información",
  },

  contact: {
    phones: "223 598 8486 / 223 451 5010",
    email: "info@hledesma.com",
    address: "Alem 2990 / Av. Luro 2634",
    website: "www.hledesma.com",
  },

  send: {
    title: "Gracias",
    subtitle: "Recibimos tus datos",
    description:
      "Un representante se pondrá en contacto con vos a la brevedad.",
  },
};
